import * as React from "react";
import {
  CaretDownOutlined,
  CaretUpOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { MenuProps, Tabs, Dropdown } from "antdv5";
import type { Obj, SetState, Fn } from "../../../client_types";
import { context } from "components/context/Context";

interface IData {
  ClockStop: string;
  ClockStart: string;
  BasicMetresPerMin: string;
  totalBird?: string;
  nowCount?: string;
  StringE_HMS: string;
  StringN_HMS: string;
}
interface IFindName {
  matchGameID: string;
  searchName: string;
  searchFeetNo: string;
}
type PreventRefreshCount = (fn: Function, count: number) => void;

interface IProps {
  countDown: number;
  findName: IFindName;
  data: IData[];
  sortText: string;
  type: string;
  resetOnClick: () => void;
  setFindName: SetState<IFindName>;
  handleDownload: Fn;
  handleList: (key: string) => void;
  handleEnter: (e: React.KeyboardEvent, fn: Fn) => void;
  handleSearch: Fn;
  handleMenuClick: (info: any) => void;
  /*
    info is of type MenuInfo from rc-menu, a dependency of ant design,
    it doesn't seem to export it for outside use so any is used as a 
    temporary workaround
  */
  preventRefreshCount: PreventRefreshCount;
  refresh: Fn;
}

const RaceliveTabs = ({
  countDown,
  findName,
  data,
  type,
  sortText,
  resetOnClick,
  setFindName,
  handleList,
  handleEnter,
  handleSearch,
  handleDownload,
  handleMenuClick,
  preventRefreshCount,
  refresh,
}: IProps) => {
  const { state } = React.useContext(context);
  const [tabItems, setTabItems] = React.useState<
    {
      key: string;
      label: string;
    }[]
  >([]);

  React.useEffect(() => {
    const StringE_HMS = data[0]?.StringE_HMS;
    const StringN_HMS = data[0]?.StringN_HMS;

    if (StringE_HMS && StringN_HMS) {
      if (StringE_HMS === "0°0′0″" && StringN_HMS === "0°0′0″") {
        setTabItems([
          {
            key: "grade",
            label: "比赛成绩",
          },
        ]);
      } else {
        setTabItems([
          {
            key: "grade",
            label: "比赛成绩",
          },
          {
            key: "gather",
            label: "集鸽列表",
          },
          // this was commented out in original code, not implemented yet?
          // {
          //   key: "detail",
          //   label: "指定明细"
          // }
        ]);
      }
    }
  }, [data]);

  const items: MenuProps["items"] = [
    {
      key: "1",
      icon: <CaretDownOutlined />,
      label: "单关排名(高到低)",
    },
    {
      key: "2",
      icon: <CaretUpOutlined />,
      label: "单关排名(低到高)",
    },
    {
      key: "5",
      icon: <CaretDownOutlined />,
      label: "单关暫排(高到低)",
    },
    {
      key: "6",
      icon: <CaretUpOutlined />,
      label: "平均暫排(低到高)",
    },
  ];

  return (
    <div className="tab">
      <div className="warninng">
        {countDown} 秒后刷新，排名以最终主办方公告为准！！
      </div>
      <Tabs
        items={tabItems}
        tabBarStyle={{ margin: "0" }}
        onChange={handleList}
        type="card"
        activeKey={type}
      />
      <div className="searchBox">
        <input
          type="text"
          onChange={(e) =>
            setFindName({ ...findName, searchName: e.target.value })
          }
          placeholder={"输入参赛名搜寻"}
          value={findName.searchName}
          onKeyDown={(e) => handleEnter(e, handleSearch)}
        />
        <input
          type="text"
          onChange={(e) =>
            setFindName({ ...findName, searchFeetNo: e.target.value })
          }
          placeholder={"输入足环号搜寻"}
          value={findName.searchFeetNo}
          onKeyDown={(e) => handleEnter(e, handleSearch)}
        />
        <div className="functionBox">
          <button
            onClick={handleSearch}
            disabled={
              findName.searchFeetNo === "" && findName.searchName === ""
            }
          >
            搜寻
          </button>
          <button onClick={resetOnClick}>重置</button>
          <button onClick={() => preventRefreshCount(refresh, 2)}>刷新</button>
          {type === "grade" ? (
            <Dropdown menu={{ items, onClick: handleMenuClick }}>
              <button>{sortText}</button>
            </Dropdown>
          ) : null}
          <button
            onClick={() => {
              window.print();
            }}
          >
            <PrinterOutlined /> 打印本页
          </button>
          {(() => {
            const onAuth = state.onAuth === "true" || state.onAuth === true;
            const isAdmin = state.character === "Admin";
            const isClub = state.character === "Club";
            const isSameClubID = state.loginClubID === state.clubID;

            if (!onAuth) return null;
            else if (isAdmin || (isClub && isSameClubID))
              return <button onClick={handleDownload}>下载表格</button>;
          })()}
        </div>
      </div>
    </div>
  );
};

export default RaceliveTabs;
